import { useMemo } from "react";

const AddressLine = ({ location }) => {
  const addressLines = useMemo(() => {
    const addressLines = [];

    if (location.city) addressLines.push(location.city);
    if (location.province) addressLines.push(location.province);
    if (location.postalCode) addressLines.push(location.postalCode);

    return addressLines.join(", ");
  }, [location]);

  return <span>{addressLines}</span>;
};

export default AddressLine;
